import * as R from 'ramda';

import {
    RESPONSES_SET_FORM,
    RESPONSES_SET_NO_RESPONSES,
    RESPONSES_SET_RESPONSES,
    RESPONSES_SET_RECIPIENT_COUNT,
    RESPONSES_SET_ACTUAL_RESPONSE_COUNT,
    RESPONSES_SET_AGGREGATED,
    RESPONSES_RESPONSES_LOADING,
    RESPONSES_RESPONSES_LOAD_COMPLETE,
    RESPONSES_FORM_LOADING,
    RESPONSES_FORM_LOAD_COMPLETE,
    RESPONSES_SURVEY_LOADING,
    RESPONSES_SURVEY_LOAD_COMPLETE,
    RESPONSES_SET_SURVEY_START_DATE,
    RESPONSES_SET_RESPONSE_COUNT,
    RESPONSES_AGGREGATED_LOADING,
    RESPONSES_AGGREGATED_LOAD_COMPLETE,
    RESPONSES_SET_DASHBOARD_REPORT,
    RESPONSES_DASHBOARD_REPORT_LOADING,
    RESPONSES_DASHBOARD_REPORT_LOAD_COMPLETE,
    RESPONSES_CLEAR_DATA,
    RESPONSES_CHANGE_VIEW,
    RESPONSES_CHANGE_RESPONSE_TYPE_TAB,
    RESPONSES_SELECT_RESPONSE,
    RESPONSES_CLEAR_RESPONSE_DATA,
    views,
    responseTabs
} from './constants';

const defaultState = {
    form: {},
    surveyStartDate: null,
    responses: null,
    noResponses: [],
    selectedResponse: null,
    recipientCount: null,
    aggregated: null,
    formLoading: true,
    aggregatedLoading: true,
    dashboardReport: null,
    dashboardReportLoading: true,
    responsesLoading: true,
    surveyLoading: true,
    views,
    // Set default here
    activeView: views.aggregate,
    responseTabs,
    activeTab: responseTabs.responses
};

const formResponses = (state = defaultState, { type, payload }) => {
    switch(type) {
        case RESPONSES_SET_FORM:
            return R.merge(state, { form: payload });
        case RESPONSES_SET_RESPONSES:
            return R.merge(state, { responses: payload });
        case RESPONSES_SET_NO_RESPONSES:
            return R.merge(state, { noResponses: payload });
        case RESPONSES_SET_RECIPIENT_COUNT:
            return R.merge(state, { recipientCount: payload })
        case RESPONSES_SET_ACTUAL_RESPONSE_COUNT:
            return R.merge(state, { actualResponseCount: payload })
        case RESPONSES_SET_AGGREGATED:
            return R.merge(state, { aggregated: payload })
        case RESPONSES_RESPONSES_LOADING:
            return R.merge(state, { responsesLoading: true });
        case RESPONSES_RESPONSES_LOAD_COMPLETE:
            return R.merge(state, { responsesLoading: false });
        case RESPONSES_FORM_LOADING:
            return R.merge(state, { formLoading: true });
        case RESPONSES_FORM_LOAD_COMPLETE:
            return R.merge(state, { formLoading: false });
         case RESPONSES_AGGREGATED_LOADING:
            return R.merge(state, { aggregatedLoading: true });
        case RESPONSES_AGGREGATED_LOAD_COMPLETE:
            return R.merge(state, { aggregatedLoading: false });
        case RESPONSES_CHANGE_VIEW:
            return R.merge(state, { activeView: payload });
        case RESPONSES_CHANGE_RESPONSE_TYPE_TAB:
            return R.merge(state, { activeTab: payload });
        case RESPONSES_CLEAR_DATA:
            return defaultState;
        case RESPONSES_SELECT_RESPONSE:
            return R.merge(state, { selectedResponse: payload });
        case RESPONSES_SET_SURVEY_START_DATE:
            return R.merge(state, { surveyStartDate: payload });
        case RESPONSES_SET_RESPONSE_COUNT:
            return R.merge(state, { responseCount: payload });
        case RESPONSES_SURVEY_LOADING:
            return R.merge(state, { surveyLoading: true });
       case RESPONSES_SURVEY_LOAD_COMPLETE:
            return R.merge(state, { surveyLoading: false });
        case RESPONSES_SET_DASHBOARD_REPORT:
            return R.merge(state, { dashboardReport: payload });
        case RESPONSES_DASHBOARD_REPORT_LOADING:
            return R.merge(state, { dashboardReportLoading: true });
        case RESPONSES_DASHBOARD_REPORT_LOAD_COMPLETE:
            return R.merge(state, { dashboardReportLoading: false });
        case RESPONSES_CLEAR_RESPONSE_DATA:
            return R.merge(state, { aggregated: null, responses: null, dashboardReport: null });
        default:
            return state;
    }
};

export default formResponses;
